



















import Vue from 'vue';
import { mapGetters } from 'vuex';
import CabinetConfigurationMakeChangesLock from '@/components/configuration/CabinetConfigurationMakeChangesLock.vue';
import MStoreQuickActions from '@/components/shared/MStoreQuickActions.vue';
import MStoreCardPanel from '@/components/shared/MStoreCardPanel.vue';
import { MStoreDashboardButtonModel, FontAwesomeIcons, CabinetConfigurationModel, StoreConstants, Configuration } from '@/types';
import CabinetSummaryInfoAlert from './CabinetSummaryInfoAlert.vue';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { CabinetSummaryOptions } from '@/types/enums/configuration/cabinet/CabinetSummaryOptions';

export default Vue.extend({
  data() {
    return {
      cabinetConfiguration: {} as CabinetConfigurationModel,
      cabinetSummaryOptionsDisplayed: [CabinetSummaryOptions.Id, CabinetSummaryOptions.DocumentTypes, CabinetSummaryOptions.CabinetReferences, CabinetSummaryOptions.DocumentLocation],
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationLockHeldByCurrentSession]),
    cabinetId(this: any) {
      return this.$route.params.cabinetId;
    },
    summaryPanelTitle(this: any) {
      return `${this.cabinetConfiguration?.description || 'Cabinet'} Summary`;
    },
    quickActionsPanelTitle(this: any) {
      return `${this.cabinetConfiguration?.description || 'Cabinet'} Quick Actions`;
    },
    dashboardButtons(this: any) {
      return [
        {
          icon: FontAwesomeIcons.CabinetFilingRegular,
          text: 'Cabinet Configuration',
          routeName: 'editCabinet',
          routeParams: {}
        },
        {
          icon: FontAwesomeIcons.Plus,
          text: 'Add Document Type',
          routeName: 'addDocumentType',
          routeParams: {},
          isDisabled: !this.cabinetConfigurationLockHeldByCurrentSession
        },
        {
          icon: FontAwesomeIcons.PaperclipRegular,
          text: 'Related Document Links',
          routeName: 'configureRelatedDocumentLinks',
          routeParams: {}
        },
        {
          icon: FontAwesomeIcons.Trash,
          text: 'Delete Cabinet',
          routeName: 'deleteCabinet',
          routeParams: {},
          isDisabled: !this.cabinetConfigurationLockHeldByCurrentSession
        },
        {
          icon: FontAwesomeIcons.Shield,
          text: 'Permissions',
          routeName: Configuration.Cabinet.CabinetSecurityConfiguration.name,
          routeParams: {
            cabinetId: this.cabinetId
          }
        }
      ] as MStoreDashboardButtonModel[];
    }
  },
  async mounted(this: any) {
    try {
      this.isLoading = true;
      this.cabinetConfiguration = await CabinetConfigurationService.getCabinetConfigurationWithErrorPageAsync(this.$route.params.cabinetId);
    } catch (error) {
      this.$log(error);
    } finally {
      this.isLoading = false;
    }
  },
  created(this: any) {
    this.FONTAWESOME_ICONS = FontAwesomeIcons;
  },
  components: {
    MStoreQuickActions,
    MStoreCardPanel,
    CabinetConfigurationMakeChangesLock,
    CabinetSummaryInfoAlert
  }
});
